type VerdictKey = 'debunked' | 'confirmed' | 'pending';

const toneMap: Record<
  VerdictKey,
  { label: string; chip: string; dot: string }
> = {
  debunked: { label: '已辟谣', chip: 'bg-secondary-100 text-secondary-900', dot: 'bg-secondary-600' },
  confirmed: { label: '已实锤', chip: 'bg-primary-100 text-primary-800', dot: 'bg-primary-600' },
  pending: { label: '求证中', chip: 'bg-accent-100 text-accent-900', dot: 'bg-accent-500' },
};

export function VerdictChip({ verdict }: { verdict: VerdictKey }) {
  const t = toneMap[verdict] ?? toneMap.pending;
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium">
      <span className={`h-1.5 w-1.5 rounded-full ${t.dot}`} />
      {t.label}
    </span>
  );
}

export function SectionHead({
  index,
  kicker,
  title,
  desc,
  id,
}: {
  index: string;
  kicker: string;
  title: string;
  desc?: string;
  id?: string;
}) {
  return (
    <div id={id} className="mb-8 md:mb-12">
      <p className="mb-3 flex items-center gap-3 font-label text-xs font-semibold tracking-[0.25em] text-primary-600">
        <span className="inline-flex h-6 w-9 items-center justify-center rounded bg-primary-500 font-heading text-sm text-background-50">
          {index}
        </span>
        栏目 · {kicker}
      </p>
      <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
          {desc}
        </p>
      ) : null}
    </div>
  );
}

export function ArrowIcon() {
  return <i className="ri-arrow-right-up-line" aria-hidden="true" />;
}